import { cssSpacing } from "../../styles/index.js";
import styled from "../../styled-components.js";
export var Popover = styled.span.withConfig({
  displayName: "Popover",
  componentId: "sc-19tjcmc-0"
})(["display:inline-flex;margin-inline-start:", ";"], cssSpacing('tighter-4', '4px'));